import { render, staticRenderFns } from "./EmailBuilder.vue?vue&type=template&id=8e28ad5e&scoped=true&"
import script from "./EmailBuilder.vue?vue&type=script&lang=js&"
export * from "./EmailBuilder.vue?vue&type=script&lang=js&"
import style0 from "./EmailBuilder.vue?vue&type=style&index=0&id=8e28ad5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e28ad5e",
  null
  
)

export default component.exports